module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "imaged"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/dline.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Series_Introduction#_idTextAnchor000"
    }
  }, [_vm._v("Series Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbrevation#_idTextAnchor001"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#_idTextAnchor002"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#_idTextAnchor003"
    }
  }, [_vm._v("Proverbs as a Theological Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#_idTextAnchor004"
    }
  }, [_vm._v("The Composition of Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#_idTextAnchor005"
    }
  }, [_vm._v("Proverbs as Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Commentry#_idTextAnchor006"
    }
  }, [_vm._v("COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor007"
    }
  }, [_vm._v("Proverbs A (Proverbs 1:1–9:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor008"
    }
  }, [_vm._v("Proverbs 1:1–33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor008"
    }
  }, [_vm._v("Wisdom, Ethics, Theology, Spirituality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor010"
    }
  }, [_vm._v("Introducing Wisdom (1:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor011"
    }
  }, [_vm._v("How Crime Doesn’t Pay (1:8–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor012"
    }
  }, [_vm._v("Wisdom the Prophet (1:20–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor013"
    }
  }, [_vm._v("Proverbs 2:1–22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor013"
    }
  }, [_vm._v("Wisdom on the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor015"
    }
  }, [_vm._v("The Nature and Purpose of Wisdom (2:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor016"
    }
  }, [_vm._v("Stupidity Embodied by Men (2:12–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor017"
    }
  }, [_vm._v("Stupidity Embodied by a Woman (2:16–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor018"
    }
  }, [_vm._v("The Cost of Turning Away (2:20–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor019"
    }
  }, [_vm._v("Proverbs 3:1–35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor019"
    }
  }, [_vm._v("Wisdom and Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor021"
    }
  }, [_vm._v("With Modesty (3:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor022"
    }
  }, [_vm._v("With Good Fortune (3:13–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor023"
    }
  }, [_vm._v("With Security (3:21–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor024"
    }
  }, [_vm._v("With Neighborliness (3:27–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor025"
    }
  }, [_vm._v("Proverbs 4:1–27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor025"
    }
  }, [_vm._v("Be Attentive to Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor027"
    }
  }, [_vm._v("Listening to Your Father (4:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor028"
    }
  }, [_vm._v("Wisdom’s Walk (4:10–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor029"
    }
  }, [_vm._v("Ear, Eyes, Mind, Mouth, Foot (4:20–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor030"
    }
  }, [_vm._v("Proverbs 5:1–23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor030"
    }
  }, [_vm._v("Marital Unfaithfulness and Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor032"
    }
  }, [_vm._v("Wisdom and Unfaithfulness (5:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor033"
    }
  }, [_vm._v("What Follows from Adultery (5:7–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor034"
    }
  }, [_vm._v("What Follows from Faithfulness (5:15–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor035"
    }
  }, [_vm._v("Unfaithfulness and Stupidity (5:20–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor037"
    }
  }, [_vm._v("Proverbs 6:1–19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor037"
    }
  }, [_vm._v("Four Forms of Stupidity or Antisocial Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor037"
    }
  }, [_vm._v("Guaranteeing (6:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor038"
    }
  }, [_vm._v("Sloth (6:6–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor039"
    }
  }, [_vm._v("Provoking Arguments … (6:12–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor040"
    }
  }, [_vm._v("… In the Family (6:16–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor041"
    }
  }, [_vm._v("Proverbs 6:20–35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor041"
    }
  }, [_vm._v("Torah, Unfaithfulness, and the Price You Pay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor043"
    }
  }, [_vm._v("Pay Heed to Instruction (6:20–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor044"
    }
  }, [_vm._v("Resist Enticement (6:24–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor045"
    }
  }, [_vm._v("Rationales (6:26–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor046"
    }
  }, [_vm._v("Proverbs 7:1–27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor046"
    }
  }, [_vm._v("The Fatal Attraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor048"
    }
  }, [_vm._v("Pay Heed to My Words and to Wisdom (7:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor049"
    }
  }, [_vm._v("The Seducer (7:5–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_ProverbA#_idTextAnchor050"
    }
  }, [_vm._v("Pay Heed to My Words and Think (7:24–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 8:1–36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom’s Activity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom Preaches in the City (8:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom Makes Her Claims (8:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom Recalls Her Past (8:22–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom Issues Her Challenge (8:32–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 9:1–18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom’s Invitation (9:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Provisos (9:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_ProverbA1#_idTextAnchor061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stupidity’s Invitation (9:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs B (Proverbs 10:1–22:16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 10:1–30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Faithful and the Faithless")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon (10:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faithfulness, Diligence, Sufficiency, Security, Recognition (10:2–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lips, Mouth, Tongue, Commands (10:8–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wealth (10:15–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plans, Fears, Expectations, Hopes (10:23–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 10:31–11:31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom and Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crooked and the Straight (10:31–11:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neighbors and Communities (11:8–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace, Beauty, and Perceptiveness (11:16–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Willingness to Risk and to Give (11:23–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 12:1–28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Faithful and the Faithless, a Reprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reprise (12:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food (12:9–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truthfulness (12:17–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lethargy and Determination (12:24–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 13:1–25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom, Discipline, Carefulness, Assets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Who Guards Their Mouth (13:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wealth and Poverty (13:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words, and Some Backup (13:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food and Folly, or Dim Sum and Dimwit (13:19–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 14:1–15:2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom, Awe for Yahweh, and the King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stupidity and Wisdom (14:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inner Being (14:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Naïve and the Neighbor (14:15–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King and God (14:26–15:2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 15:3–33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yahweh-Exposure, Awe, Outrage; Discipline, Correction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eyes of Yahweh, Watching (15:3–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Awe for Yahweh and a Happy Heart (15:13–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outrage to Yahweh and Tearing Away (15:25–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 16:1–30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yahweh and the King, the Judicious and the Scoundrel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Action of Human Beings and the Action of Yahweh (16:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The King (16:10–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Judicious Individual (16:16–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB#_idTextAnchor104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoundrel (16:27–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 16:31–17:26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heroes and Villains and Dimwits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heroes Crowned, and Dimwits They Watch (16:31–17:6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Villains, and Dimwits among Them (17:7–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dimwits, and Villains among Them (17:16–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 17:27–19:7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words Spoken and Unspoken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Wisdom and Folly Lie (17:27–18:9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Strength Lies (18:10–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between Badly Off and Well Off (18:22–19:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 19:8–20:1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom and Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom in an Individual’s Life (19:8–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom in the Family (19:13–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom in an Individual’s Life (19:20–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom in the Family (19:24–20:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 20:2–21:3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Power and Divine Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The King’s Winnowing (20:2–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things People Say (20:14–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yahweh’s Sovereignty (20:23–21:3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 21:4–31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Faithless and the Faithful")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aims and Desires (21:4–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom and Judiciousness (21:11–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Gallery of Wise Men and Rogues (21:21–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 22:1–16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Well Off and the Badly Off, and a Reprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Well Off and the Badly Off (22:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_ProverbB1#_idTextAnchor134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Reprise (22:10–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs C (Proverbs 22:17–31:31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 22:17–23:11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of the Wise, Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction (22:17–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Poor, the Angry, the Debtor, and the Family Land (22:22–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Relating to the Administration (22:29–23:3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wealthy, the Mean, the Fool, and the Parentless (23:4–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 23:12–24:22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of the Wise, Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discipline (23:12–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinking, Overeating, Honoring, Whoring (23:19–24:2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom Builds, Battles, Speaks, Discerns, Satisfies (24:3–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Lie in Wait, Don’t Exult, Don’t Fret, Don’t Mix (24:15–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 24:23–34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of the Wise, Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and Work (1) (24:23–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and Work (2) (24:28–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 25:1–28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sayings Copied for Hezekiah, Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The King (25:1–7a)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Involvement in Decision-Making (25:7b–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endangering Relationships (25:16–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conflicted Relationships (25:21–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 26:1–28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sayings Copied for Hezekiah, Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dimwit (26:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Slacker (26:13–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Disputant (26:17–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fraud (26:23–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 27:1–27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sayings Copied for Hezekiah, Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outsider and Other, Neighbor and Friend (27:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom and Stupidity, Outsider and Neighbor (27:11–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sheep Farm (27:23–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 28:1–28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sayings Copied for Hezekiah, Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heeding and Abandoning Instruction (28:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Misleading Leader (28:10–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC#_idTextAnchor173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Be Full (28:19–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 29:1–27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sayings Copied for Hezekiah, Part Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom and Happiness (29:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Authority and Discipline (29:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yahweh and Outrage (29:22–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 30:1–33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of Agur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking about Wisdom (30:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking about People (30:10–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking about Order (30:21–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs 31:1–31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of Lemuel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mother’s Utterance (31:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_ProverbC1#_idTextAnchor187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Resourceful Woman (31:10–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Conclusion#_idTextAnchor188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Conclusion#_idTextAnchor189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Actions and Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Conclusion#_idTextAnchor190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs in the Context of the Scriptures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Conclusion#_idTextAnchor191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Bibliogrpahy#_idTextAnchor192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27bbe38a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0